import React from "react";
import "./sampleOrder.scss"
import SelectDiv from '../../components/selectDiv/selectDiv'

export default class SampleOrder extends React.Component{
    constructor(props){
        super(props);
        this.state={
            type:1
        }
        
    }
    
    
    render(){
        return(
            <div className="SampleOrder">
                <div className="top">
                    <div>
                        <span className={this.state.type==1?"activeType":""}>储备申请</span>
                        {
                            this.state.type==1&&
                            <p></p>
                        }
                    </div>
                    <div>
                        <span className={this.state.type==2?"activeType":""}>储备申请</span>
                        {
                            this.state.type==2&&
                            <p></p>
                        }
                    </div>
                </div>
                <div className="content">
                    <ul>
                        <li>
                            <div className="fromTitle">客户姓名</div>
                            
                        </li>
                        <li>
                            <div className="fromTitle">产品名称</div>
                        </li>
                        <li>
                            <div className="fromTitle">产品数量</div>
                        </li>
                        <li>
                            <div className="fromTitle">备注</div>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }
    componentWillReceiveProps(nextProps) {
        
        
        
    }
    async componentDidMount(){
        
    }
}

